// Photos used on public pages, with the credit their licences require (all from Wikimedia Commons).
export interface Photo { url: string; credit: string; source: string }

export const HERO_PHOTOS: Record<'port' | 'mine' | 'bess', Photo> = {
  "port": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/5/58/The_Port_of_Port_Hedland%2C_2023%2C_01.jpg/960px-The_Port_of_Port_Hedland%2C_2023%2C_01.jpg",
    "credit": "Kgbo · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:The_Port_of_Port_Hedland,_2023,_01.jpg"
  },
  "mine": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/a/a5/Open_pit_of_the_Greenbushes_mine%2C_January_2023_07.jpg/960px-Open_pit_of_the_Greenbushes_mine%2C_January_2023_07.jpg",
    "credit": "Calistemon · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Open_pit_of_the_Greenbushes_mine,_January_2023_07.jpg"
  },
  "bess": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/c/c6/Tesvolt_battery_energy_storage_system_Rheineck.jpg/960px-Tesvolt_battery_energy_storage_system_Rheineck.jpg",
    "credit": "Kecko from Eastern Switzerland · CC BY 2.0",
    "source": "https://commons.wikimedia.org/wiki/File:Tesvolt_battery_energy_storage_system_Rheineck.jpg"
  }
};

export const PRODUCT_PHOTOS: Record<string, Photo> = {
  "spodumene_sc6": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/a/a0/Spodumene_%28GeoDIL_number_-_400%29.jpg/960px-Spodumene_%28GeoDIL_number_-_400%29.jpg",
    "credit": "Shannon Heinle · CC0",
    "source": "https://commons.wikimedia.org/wiki/File:Spodumene_(GeoDIL_number_-_400).jpg"
  },
  "lioh_battery": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/8/88/LiOH_2009.jpg/960px-LiOH_2009.jpg",
    "credit": "Xavier13540 · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:LiOH_2009.jpg"
  },
  "li2co3_battery": {
    "url": "https://upload.wikimedia.org/wikipedia/commons/f/f4/Lithium_carbonate.jpg",
    "credit": "Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Lithium_carbonate.jpg"
  },
  "nickel_sulphate": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/b/b2/Nickel%28II%29-sulfate-hexahydrate-sample.jpg/960px-Nickel%28II%29-sulfate-hexahydrate-sample.jpg",
    "credit": "Benjah-bmm27 · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Nickel(II)-sulfate-hexahydrate-sample.jpg"
  },
  "cobalt_sulphate": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/7c/Cobalt%28II%29_sulfate.jpg/960px-Cobalt%28II%29_sulfate.jpg",
    "credit": "Adam Rędzikowski · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Cobalt(II)_sulfate.jpg"
  },
  "graphite_flake": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/a/a9/Graphite_%28Ceylon%29_36.jpg/960px-Graphite_%28Ceylon%29_36.jpg",
    "credit": "James St. John · CC BY 2.0",
    "source": "https://commons.wikimedia.org/wiki/File:Graphite_(Ceylon)_36.jpg"
  },
  "spodumene_low_grade": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/5/5e/Spodumene_11.jpg/960px-Spodumene_11.jpg",
    "credit": "Géry PARENT · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Spodumene_11.jpg"
  },
  "cobalt_hydroxide": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/f/fa/Cobalt%28II%29_hydroxide_%282%29.JPG/960px-Cobalt%28II%29_hydroxide_%282%29.JPG",
    "credit": "Chemicalinterest · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Cobalt(II)_hydroxide_(2).JPG"
  },
  "lioh_technical": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/b/ba/Lithium_hydroxide_with_carbonate_growths.JPG/960px-Lithium_hydroxide_with_carbonate_growths.JPG",
    "credit": "Chemicalinterest · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Lithium_hydroxide_with_carbonate_growths.JPG"
  },
  "li2co3_technical": {
    "url": "https://upload.wikimedia.org/wikipedia/commons/5/55/Lithium_carbonate_A.jpg",
    "credit": "Aariuser I · CC BY-SA 2.0",
    "source": "https://commons.wikimedia.org/wiki/File:Lithium_carbonate_A.jpg"
  },
  "manganese_sulphate": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/1/18/Manganese%28II%29-sulfate-photo.jpg/960px-Manganese%28II%29-sulfate-photo.jpg",
    "credit": "Benjah-bmm27 · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Manganese(II)-sulfate-photo.jpg"
  },
  "graphite_spherical": {
    "url": "https://upload.wikimedia.org/wikipedia/commons/b/b3/Graphite_powder.jpg",
    "credit": "K. Murray · CC BY-SA 3.0",
    "source": "https://commons.wikimedia.org/wiki/File:Graphite_powder.jpg"
  },
  "graphite_synthetic": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/0/0f/Glassy_carbon_and_a_1cm3_graphite_cube_HP68-79.jpg/960px-Glassy_carbon_and_a_1cm3_graphite_cube_HP68-79.jpg",
    "credit": "Alchemist-hp · FAL",
    "source": "https://commons.wikimedia.org/wiki/File:Glassy_carbon_and_a_1cm3_graphite_cube_HP68-79.jpg"
  },
  "cam_nmc811": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/d/d6/NCM811-micro_roses.jpg/960px-NCM811-micro_roses.jpg",
    "credit": "Altynay.Kaiyrgali · CC BY 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:NCM811-micro_roses.jpg"
  },
  "cam_lfp": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/c/cc/Lithium_Iron_Phosphate_LiFePO4_Cells_400_Ah_Amp_Hours_3.25_Volts_-_5.jpg/960px-Lithium_Iron_Phosphate_LiFePO4_Cells_400_Ah_Amp_Hours_3.25_Volts_-_5.jpg",
    "credit": "Yo-Co-Man · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Lithium_Iron_Phosphate_LiFePO4_Cells_400_Ah_Amp_Hours_3.25_Volts_-_5.jpg"
  },
  "battery_cells_prismatic": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/b/b6/Lithium_Iron_Phosphate_LiFePO4_Cells_700_Ah_Amp_Hours_3.25_Volts_-_7.jpg/960px-Lithium_Iron_Phosphate_LiFePO4_Cells_700_Ah_Amp_Hours_3.25_Volts_-_7.jpg",
    "credit": "Yo-Co-Man · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Lithium_Iron_Phosphate_LiFePO4_Cells_700_Ah_Amp_Hours_3.25_Volts_-_7.jpg"
  },
  "battery_packs_ev_bess": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/d/d6/Air-cooled_industrial_and_commercial_battery_energy_storage_system.jpg/960px-Air-cooled_industrial_and_commercial_battery_energy_storage_system.jpg",
    "credit": "Yan lance · CC0",
    "source": "https://commons.wikimedia.org/wiki/File:Air-cooled_industrial_and_commercial_battery_energy_storage_system.jpg"
  },
  "sulphuric_acid": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/6/69/Sulfuric_acid_H2SO4.jpg/960px-Sulfuric_acid_H2SO4.jpg",
    "credit": "Ljeto · CC BY 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Sulfuric_acid_H2SO4.jpg"
  },
  "soda_ash": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/3/3a/Production_site_for_sodium_carbonate_near_Dombasle-sur-Meurthe_France_%2819630816513%29.jpg/960px-Production_site_for_sodium_carbonate_near_Dombasle-sur-Meurthe_France_%2819630816513%29.jpg",
    "credit": "Jeroen Komen from Utrecht, Netherlands · CC BY-SA 2.0",
    "source": "https://commons.wikimedia.org/wiki/File:Production_site_for_sodium_carbonate_near_Dombasle-sur-Meurthe_France_(19630816513).jpg"
  },
  "caustic_soda": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/3/34/SodiumHydroxide.jpg/960px-SodiumHydroxide.jpg",
    "credit": "Walkerma · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:SodiumHydroxide.jpg"
  },
  "quicklime": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/5/56/Calcium_oxide_powder.JPG/960px-Calcium_oxide_powder.JPG",
    "credit": "Leiem · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Calcium_oxide_powder.JPG"
  },
  "sodium_sulphate": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/0/05/Glaubersalz_%28Granulat%29.jpg/960px-Glaubersalz_%28Granulat%29.jpg",
    "credit": "Rhetos · CC0",
    "source": "https://commons.wikimedia.org/wiki/File:Glaubersalz_(Granulat).jpg"
  },
  "lipf6": {
    "url": "https://upload.wikimedia.org/wikipedia/commons/a/a1/Lithium_nitrate.jpg",
    "credit": "Wikimedia Commons · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Lithium_nitrate.jpg"
  },
  "electrolyte": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/b/b1/Dinitrosalicylic_acid_reagent.jpg/960px-Dinitrosalicylic_acid_reagent.jpg",
    "credit": "PeaceSeekers · CC BY 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Dinitrosalicylic_acid_reagent.jpg"
  },
  "separator": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/f/f4/Navid_Selfon_plant_-_film_roll_warehouse%2C_Tehran_%282026%29.jpg/960px-Navid_Selfon_plant_-_film_roll_warehouse%2C_Tehran_%282026%29.jpg",
    "credit": "Navid Selfon · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Navid_Selfon_plant_-_film_roll_warehouse,_Tehran_(2026).jpg"
  },
  "copper_foil": {
    "url": "https://upload.wikimedia.org/wikipedia/commons/b/ba/CopperFoil.jpg",
    "credit": "Lloyd Davis from London, UK · CC BY-SA 2.0",
    "source": "https://commons.wikimedia.org/wiki/File:CopperFoil.jpg"
  },
  "aluminium_foil": {
    "url": "https://upload.wikimedia.org/wikipedia/commons/5/55/A_roll_of_aluminum_foil.jpg",
    "credit": "ShriniwasGajare · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:A_roll_of_aluminum_foil.jpg"
  },
  "pvdf": {
    "url": "https://upload.wikimedia.org/wikipedia/commons/3/32/PMCC_powder.jpg",
    "credit": "Unknown authorUnknown author · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:PMCC_powder.jpg"
  },
  "conductive_carbon": {
    "url": "https://upload.wikimedia.org/wikipedia/commons/9/98/Carbon_black.jpg",
    "credit": "FK1954 · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Carbon_black.jpg"
  },
  "lithium_metal": {
    "url": "https://upload.wikimedia.org/wikipedia/commons/a/ae/Lithium_paraffin.jpg",
    "credit": "Tomihahndorf at German Wikipedia · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Lithium_paraffin.jpg"
  },
  "lithium_chloride": {
    "url": "https://upload.wikimedia.org/wikipedia/commons/4/4d/Lithium_chloride.jpg",
    "credit": "January 2005 by User:Walkerma · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Lithium_chloride.jpg"
  },
  "nickel_metal": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/6/6a/Nickel_electrolytic_and_1cm3_cube.jpg/960px-Nickel_electrolytic_and_1cm3_cube.jpg",
    "credit": "Alchemist-hp · FAL",
    "source": "https://commons.wikimedia.org/wiki/File:Nickel_electrolytic_and_1cm3_cube.jpg"
  },
  "cobalt_metal": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/4/4b/Cobalt-Metall.JPG/960px-Cobalt-Metall.JPG",
    "credit": "J. Murawski · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Cobalt-Metall.JPG"
  },
  "pcam_nmc": {
    "url": "https://upload.wikimedia.org/wikipedia/commons/c/cc/Cobalt_hydroxide.JPG",
    "credit": "Chemicalinterest · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Cobalt_hydroxide.JPG"
  },
  "lepidolite": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/d/dd/Radiating_lepidolite_White_Elephant_Mine_SD.jpg/960px-Radiating_lepidolite_White_Elephant_Mine_SD.jpg",
    "credit": "Jstuby · CC0",
    "source": "https://commons.wikimedia.org/wiki/File:Radiating_lepidolite_White_Elephant_Mine_SD.jpg"
  },
  "nickel_mhp": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/e/ee/005_Nickel-ore.jpg/960px-005_Nickel-ore.jpg",
    "credit": "Ronald Werner · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:005_Nickel-ore.jpg"
  },
  "black_mass": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/a/ab/Battery_recycling.jpg/960px-Battery_recycling.jpg",
    "credit": "Santeri Viinamäki · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Battery_recycling.jpg"
  },
  "copper_cathode": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/8/8d/Copper_cathode_UMMCII_Uralelectromed.jpg/960px-Copper_cathode_UMMCII_Uralelectromed.jpg",
    "credit": "Niklitov · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Copper_cathode_UMMCII_Uralelectromed.jpg"
  },
  "ndpr_oxide": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/9/92/Neodymium_oxide_sample.jpg/960px-Neodymium_oxide_sample.jpg",
    "credit": "Leiem · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Neodymium_oxide_sample.jpg"
  },
  "vanadium_pentoxide": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/8/8a/Vanadium_pentoxide.jpg/960px-Vanadium_pentoxide.jpg",
    "credit": "Choij · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Vanadium_pentoxide.jpg"
  },
  "manganese_ore": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/a/ac/Manganese_ore.jpg/960px-Manganese_ore.jpg",
    "credit": "கவிக்குமார் ப · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Manganese_ore.jpg"
  },
  "ilmenite": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/9/9b/Ilmenite_sand.jpg/960px-Ilmenite_sand.jpg",
    "credit": "Mx. Granger · CC0",
    "source": "https://commons.wikimedia.org/wiki/File:Ilmenite_sand.jpg"
  },
  "zircon": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/9/9b/Iziko_Mineral_Zircon.JPG/960px-Iziko_Mineral_Zircon.JPG",
    "credit": "Nkansah Rexford · CC BY 3.0",
    "source": "https://commons.wikimedia.org/wiki/File:Iziko_Mineral_Zircon.JPG"
  },
  "liion_scrap_cells": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/5/52/Used_batteries.jpg/960px-Used_batteries.jpg",
    "credit": "Peter Fiskerstrand · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Used_batteries.jpg"
  },
  "liion_scrap_ev": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/72/Tesla_Roadster_Sport_battery_pack_rear.jpg/960px-Tesla_Roadster_Sport_battery_pack_rear.jpg",
    "credit": "Norio Nakayama · CC BY-SA 2.0",
    "source": "https://commons.wikimedia.org/wiki/File:Tesla_Roadster_Sport_battery_pack_rear.jpg"
  },
  "liion_production_scrap": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/76/Electrode_Slurry_Mixing.JPG/960px-Electrode_Slurry_Mixing.JPG",
    "credit": "RudolfSimon · CC BY 3.0",
    "source": "https://commons.wikimedia.org/wiki/File:Electrode_Slurry_Mixing.JPG"
  },
  "lead_acid_scrap": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/0/08/Recycling_lead_in_a_lead-acid_battery_recovery_facility.jpg/960px-Recycling_lead_in_a_lead-acid_battery_recovery_facility.jpg",
    "credit": "National Institute for Occupational Safety and Health (NIOSH",
    "source": "https://commons.wikimedia.org/wiki/File:Recycling_lead_in_a_lead-acid_battery_recovery_facility.jpg"
  },
  "ewaste_pcb": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/b/b8/Brokencircuitboard2011.jpg/960px-Brokencircuitboard2011.jpg",
    "credit": "Guinnog · CC BY-SA 3.0",
    "source": "https://commons.wikimedia.org/wiki/File:Brokencircuitboard2011.jpg"
  },
  "ewaste_devices": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/6/65/Electronic_waste.jpg/960px-Electronic_waste.jpg",
    "credit": "Curtis Palmer · CC BY 2.0",
    "source": "https://commons.wikimedia.org/wiki/File:Electronic_waste.jpg"
  },
  "copper_scrap_1": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/a/a2/Copper-clad_aluminum_%28CCA%29_coiled_wire.png/960px-Copper-clad_aluminum_%28CCA%29_coiled_wire.png",
    "credit": "Pavlo Polishchuk · CC BY 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Copper-clad_aluminum_(CCA)_coiled_wire.png"
  },
  "copper_scrap_2": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/3/30/Copper_water_pipes.jpg/960px-Copper_water_pipes.jpg",
    "credit": "Santeri Viinamäki · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Copper_water_pipes.jpg"
  },
  "copper_cable_scrap": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/77/Elevator_Cable_Scrap.JPG/960px-Elevator_Cable_Scrap.JPG",
    "credit": "Erikrhendrickson · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Elevator_Cable_Scrap.JPG"
  },
  "brass_scrap": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/8/82/La_empresa.jpg/960px-La_empresa.jpg",
    "credit": "Recemsa · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:La_empresa.jpg"
  },
  "aluminium_scrap_sheet": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/4/4b/Collection_of_scrap_aluminium_in_Welshpool_by_the_Women%27s_Voluntary_Service_%281461300%29.jpg/960px-Collection_of_scrap_aluminium_in_Welshpool_by_the_Women%27s_Voluntary_Service_%281461300%29.jpg",
    "credit": "Geoff Charles · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Collection_of_scrap_aluminium_in_Welshpool_by_the_Women's_Voluntary_Service_(1461300).jpg"
  },
  "aluminium_ubc": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/c/ca/Camp_Pendleton%27s_occupants_recycle_more_than_22%2C000_aluminum_cans_every_three_weeks.jpg/960px-Camp_Pendleton%27s_occupants_recycle_more_than_22%2C000_aluminum_cans_every_three_weeks.jpg",
    "credit": "Wikimedia Commons · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Camp_Pendleton's_occupants_recycle_more_than_22,000_aluminum_cans_every_three_weeks.jpg"
  },
  "aluminium_castings_scrap": {
    "url": "https://upload.wikimedia.org/wikipedia/commons/0/04/Bundesarchiv_Bild_183-1987-0108-003%2C_Chemiekombinat_Bitterfeld%2C_Aluminiumschrott-Betrieb.jpg",
    "credit": "Thomas Lehmann · CC BY-SA 3.0 de",
    "source": "https://commons.wikimedia.org/wiki/File:Bundesarchiv_Bild_183-1987-0108-003,_Chemiekombinat_Bitterfeld,_Aluminiumschrott-Betrieb.jpg"
  },
  "zorba": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/e/ec/Scrap_metal.jpg/960px-Scrap_metal.jpg",
    "credit": "Paul Goyette · CC BY-SA 2.0",
    "source": "https://commons.wikimedia.org/wiki/File:Scrap_metal.jpg"
  },
  "aluminium_ingot_primary": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/f/f1/Aluminum_ingots_loaded_on_truck.jpg/960px-Aluminum_ingots_loaded_on_truck.jpg",
    "credit": "Fumikas Sagisavas · CC0",
    "source": "https://commons.wikimedia.org/wiki/File:Aluminum_ingots_loaded_on_truck.jpg"
  },
  "aluminium_alloy_ingot": {
    "url": "https://upload.wikimedia.org/wikipedia/commons/c/c2/Alba_Production2.jpg",
    "credit": "Alba4world · CC BY-SA 3.0",
    "source": "https://commons.wikimedia.org/wiki/File:Alba_Production2.jpg"
  },
  "copper_wire_rod": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/c/c6/Modern_Wire_fragment_%28FindID_976624%29.jpg/960px-Modern_Wire_fragment_%28FindID_976624%29.jpg",
    "credit": "North Lincolnshire Museum, Martin Foreman, 2019-10-24 12:42:",
    "source": "https://commons.wikimedia.org/wiki/File:Modern_Wire_fragment_(FindID_976624).jpg"
  },
  "copper_busbar": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/3/33/Dornbirn-old_main_earthing_busbar_%28copper%29-01ASD.jpg/960px-Dornbirn-old_main_earthing_busbar_%28copper%29-01ASD.jpg",
    "credit": "Asurnipal · CC BY-SA 4.0",
    "source": "https://commons.wikimedia.org/wiki/File:Dornbirn-old_main_earthing_busbar_(copper)-01ASD.jpg"
  },
  "aluminium_busbar": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/c/c6/Busbar_for_zero_wires_distribution.JPG/960px-Busbar_for_zero_wires_distribution.JPG",
    "credit": "Dmitry G · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Busbar_for_zero_wires_distribution.JPG"
  },
  "lead_ingot": {
    "url": "https://thumb.wikimedia.org/wikipedia/commons/thumb/6/64/Lead_ingots.JPG/960px-Lead_ingots.JPG",
    "credit": "Rodw · Public domain",
    "source": "https://commons.wikimedia.org/wiki/File:Lead_ingots.JPG"
  }
};
